/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './gateway-log.scss';

import gatewayLogPayload from './gateway-log-payload.tpl.html';

/*@ngInject*/
export default function GatewayLogController($scope, $rootScope, $mdMedia, $translate, $document, $mdDialog, $filter, types, gatewayLogService) {
    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.allGatewayLogs = [];
        vm.totalElemets = 0;
        vm.gatewayLogs = [];
        vm.rowsCount = 0;
        vm.query = {
            order: '-ts',
            limit: 15,
            page: 1,
        };
        vm.limitOptions = [15, 30, 45];
        vm.filter = {};

        vm.reload = reload;
        vm.reloadFromFirstPage = reloadFromFirstPage;
        vm.showGatewayLogPayload = showGatewayLogPayload;

        vm.config = {
            timewindow: {
                fixedTimewindow: {
                    minStartDateMs: Date.now() - 24 * 60 * 60 * 1000
                }
            }
        }

        vm.loading = function () {
            return $rootScope.loading;
        };

        vm.onPaginate = function () {
            reload();
        };

        vm.onReorder = function () {
            updateGatewayLogs();
        };

        resetFilters();
        reload();
    };

    $scope.$watch("vm.filter.timewindow", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reloadFromFirstPage();
        }
    }, true);

    $scope.$watch("vm.filter.msgType", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reloadFromFirstPage();
        }
    });

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    function resetFilters() {
        vm.filter = {
            timewindow: {
                history: {
                    timewindowMs: 60 * 60 * 1000, // 1 hour
                    max: 24 * 60 * 60 * 1000
                }
            },
            mac: '',
            deviceEui: '',
            msgType: [],
        };
    }

    function reloadFromFirstPage() {
        vm.query.page = 1;
        reload()
    }

    function reload() {
        var startTs;
        var endTs;

        if (vm.filter.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            startTs = currentTime - vm.filter.timewindow.history.timewindowMs;
            endTs = currentTime;
        } else {
            startTs = vm.filter.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.filter.timewindow.history.fixedTimewindow.endTimeMs;
        }
        vm.gatewayLogPromise = gatewayLogService.getGatewayLogScroll(startTs, endTs, vm.query.limit, (vm.query.page - 1), vm.filter.mac, vm.filter.deviceEui, vm.filter.msgType);

        if (vm.gatewayLogPromise) {
            vm.gatewayLogPromise.then(
                (result) => {
                    if (!result.data) {
                        result.data = []
                    }
                    if (result.data.length > 0 || result.page === 0) {
                        vm.gatewayLogs.length = 0;
                        vm.rowsCount = 0;
                        vm.allGatewayLogs = result.data;
                        vm.allGatewayLogs.forEach((gatewayLog) => {
                            gatewayLog.msgType = $translate.instant(vm.types.gatewayMsgType[gatewayLog.msgType].name);
                            gatewayLog.payload = gatewayLog.msgBody;
                        });
                        vm.totalElemets = getTotalElements(result);
                        updateGatewayLogs();
                    } else {
                        revertPageInPaginator();
                    }
                },
                () => {
                    updateGatewayLogs();
                }
            );
        }
    }

    function revertPageInPaginator() {
        vm.query.page--;
        vm.totalElemets--;
    }

    // This is done to reuse the same table-pagination component for scrolling pagination
    function getTotalElements(result) {
        let totalElements = result.page * result.limit + result.data.length;
        if (result.data.length === result.limit) {
            totalElements++;
        }
        return totalElements;
    }

    function showGatewayLogPayload($event, payload) {
        if (payload) {
            var onShowingCallback = {
                onShowing: function () {
                }
            };
            $mdDialog.show({
                controller: 'GatewayLogPayloadController',
                controllerAs: 'vm',
                templateUrl: gatewayLogPayload,
                locals: {
                    payload: payload,
                    showingCallback: onShowingCallback
                },
                parent: angular.element($document[0].body),
                targetEvent: $event,
                fullscreen: true,
                skipHide: true,
                onShowing: function (scope, event) {
                    onShowingCallback.onShowing(scope, event);
                }
            });
        }
    }

    function updateGatewayLogs() {
        var result = $filter('orderBy')(vm.allGatewayLogs, vm.query.order);
        if (vm.totalElemets > vm.query.limit) {
            vm.rowsCount = vm.totalElemets;
        } else {
            vm.rowsCount = result.length;
        }
        vm.gatewayLogs = result;
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway-log/gateway-log.controller.js